import templateUrl from './massia.default.filters.tpl.html';
import controller from './massia.default.filters.controller';
import {
	autoSocieteDirective,
	autoSiteDirective,
	autoRegroupementSiteDirective,
	hideIfDefaultSocieteDirective,
	hideIfDefaultSiteDirective,
	hideIfDefaultSocieteAndSiteDirective
} from './massia.default.filters.directives';

export const component = {
	bindings: {},
	template: templateUrl,
	controller: controller
};

export {
	autoSocieteDirective,
	autoSiteDirective,
	autoRegroupementSiteDirective,
	hideIfDefaultSocieteDirective,
	hideIfDefaultSiteDirective,
	hideIfDefaultSocieteAndSiteDirective
};
